const form5 = {
  formId5: "new-user-form5",
  formField5: {
    taxpayerName: {
      name: "taxpayerName",
      label: "[01] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[02] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[03] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[04] Mã số thuế đại lý:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
  },
};

export default form5;
